module.exports = __webpack_public_path__ + "static/media/meeting_minds.fd4ca183.png";